import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';

class SearchableDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      value: '',
      filteredItems: [],
    };
  }

  componentDidMount() {
    const { apiUrl } = this.props;
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          items: data,
          filteredItems: data,
        })
      )
      .catch((error) => console.error(error));
  }

  handleInputChange = (event) => {
    const currentValue = event.target.value.toLowerCase();
    const { items } = this.state;
    const filtered = items.filter((item) =>
      item.nombre.toLowerCase().includes(currentValue)
    );
    this.setState({
      value: currentValue,
      filteredItems: filtered,
    });
  };

  render() {
    const { elementName, onClick } = this.props;
    const { value, filteredItems } = this.state;

    return (
      <Dropdown>
        <Dropdown.Toggle variant="light" id="dropdown-basic">
          Seleccionar organización o colectivo
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Form.Group controlId="formBasicSearch">
            <Form.Control
              type="text"
              placeholder="Search"
              value={value}
              onChange={this.handleInputChange}
            />
          </Form.Group>
          {filteredItems.map((item) => (
            <Dropdown.Item
              key={item._id}
              onClick={() => onClick(item, elementName)}
            >
              {item.nombre}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

SearchableDropdown.propTypes = {
  apiUrl: PropTypes.string.isRequired,
  elementName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default SearchableDropdown;